import Styles from './styles.module.scss';
import {useNavigate} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../_UI/logo';

import telIcon from '../../theme/assets/svg/tc_soc_tel.svg';
import instIcon from '../../theme/assets/svg/tc_soc_inst.svg';
import twitIcon from '../../theme/assets/svg/tc_soc_twit.svg';
import ytIcon from '../../theme/assets/svg/tc_soc_yt.svg';

import {buildCrossDomainLink} from "../../utils/buildCrossDomainLink";
import i18n from "../../helpers/i18n";

const Footer = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    // const scrollToSection = (id) => {
    //     const el = document.getElementById(id);
    //     if (el) {
    //         el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     }
    // };

    return (
        <footer className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={Styles.topWrap}>
                    <div className={Styles.line} />

                    <div className={Styles.topBox}>
                        <div className={Styles.infoBox}>
                            <a
                                href={buildCrossDomainLink({
                                    baseUrl: process.env.REACT_APP_NEXT_URL,
                                    path: '/',
                                    lang: i18n.language?.startsWith('ru') ? 'ru' : 'en',
                                })}
                                className={Styles.logoWrap}
                            >
                                <Logo />
                            </a>

                            <div className={Styles.infoBoxNote}>
                                {t('Оставьте свой след в блокчейне. Пусть будущее услышит ваше настоящее.')}
                            </div>
                        </div>

                        <div className={Styles.navWrap}>
                            <div className={Styles.navTitle}>{t('ДОКУМЕНТЫ')}</div>

                            <div className={Styles.navBox}>
                                <div className={Styles.navBoxItem} onClick={()=>{navigate('/white-paper')}}>White Paper</div>
                                <div className={Styles.navBoxItem}
                                     onClick={() => {
                                         window.open("https://honeestarter.s3.eu-central-1.amazonaws.com/docs/PrivacyPolicy.pdf", "_blank");
                                     }}
                                >
                                    {t('Политика конфиденциальности')}
                                </div>
                                <div className={Styles.navBoxItem}
                                     onClick={() => {
                                         window.open("https://honeestarter.s3.eu-central-1.amazonaws.com/docs/TermsOfUse.pdf", "_blank");
                                     }}
                                >
                                    {t('Условия использования')}
                                </div>
                            </div>
                        </div>

                        <div className={Styles.socWrap}>
                            <div className={Styles.socTitle}>{t('Наши социальные сети:')}</div>

                            <div className={Styles.socBox}>
                                <div className={Styles.socBoxItem}
                                     onClick={() => {
                                         window.open("https://t.me/official_time_capsule", "_blank");
                                     }}
                                >
                                    <img src={telIcon} alt="Telegram" />
                                </div>

                                <div className={Styles.socBoxItem}
                                     onClick={() => {
                                         window.open("https://www.instagram.com/official_capsuletime/", "_blank");
                                     }}
                                >
                                    <img src={instIcon} alt="Instagram" />
                                </div>

                                <div className={Styles.socBoxItem}
                                     onClick={() => {
                                         window.open("https://time-capsule.gitbook.io/white-book", "_blank");
                                     }}
                                >
                                    <img src={twitIcon} alt="WB" />
                                </div>

                                <div className={Styles.socBoxItem}
                                     onClick={() => {
                                         window.open("https://youtube.com/@projecttc?si=HsZMkRmPHcoHqdLG", "_blank");
                                     }}
                                >
                                    <img src={ytIcon} alt="YouTube" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={Styles.bottomWrap}>
                    <div className={Styles.line} />

                    <div className={Styles.bottomWrapNote}>
                        {t('Copyright © 2025 TimeCapsule | Все права защищены')}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;


